import axios from "axios";
import store from "@/store";
import { getXAuthToken, getXAuthAgent } from "@/utils/auth";

const serviceDownload = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 120000
});

serviceDownload.interceptors.request.use(
  config => {
    if (store.getters.x_auth_token != "") {
      config.headers["X-Auth-Token"] = "Bearer " + store.getters.x_auth_token;
    } else if (getXAuthToken() != "" && getXAuthToken() != null) {
      config.headers["X-Auth-Token"] = "Bearer " + getXAuthToken();
    }
    if (store.getters.x_auth_agent != "") {
      config.headers["X-Auth-Agent"] = "Bearer " + store.getters.x_auth_agent;
    } else if (getXAuthAgent() != "" && getXAuthAgent() != null) {
      config.headers["X-Auth-Agent"] = "Bearer " + getXAuthAgent();
    }
    return config;
  },
  error => Promise.reject(error)
);

serviceDownload.interceptors.response.use(
  response => response,
  error => {
    const response = error && error.response ? error.response : null;
    if (
      !response ||
      typeof Blob === "undefined" ||
      !(response.data instanceof Blob)
    ) {
      return Promise.reject(error);
    }

    return response.data
      .text()
      .then(text => {
        try {
          response.data = JSON.parse(text);
        } catch (parseError) {
          response.data = null;
        }
        return Promise.reject(error);
      })
      .catch(() => Promise.reject(error));
  }
);

export default serviceDownload;



// WEBPACK FOOTER //
// ./src/utils/requestDownload.js